import { Chip } from '@mui/material'
import { TASK_STATE_COLOR, TASK_STATE_TEXT_COLOR } from './TaskStateColor'
import { QcTaskState } from '@common/config/api/client'
import { formatTaskStateText } from '../utils'
import { AccessTimeFilledRounded } from '@mui/icons-material'
import { SPACING } from '@common/theme/spacing'

const isPending = (taskState: QcTaskState) => {
  return taskState === 'RESET_PENDING_APPROVAL'
}

const removePending = (taskState: QcTaskState) => {
  return taskState.replace('_PENDING_APPROVAL', '')
}

export default function TaskStateChip({ taskState }: { taskState: QcTaskState }) {
  const state = isPending(taskState) ? removePending(taskState) : taskState

  return (
    <Chip
      data-testid="task-status-chip"
      label={formatTaskStateText(state)}
      deleteIcon={isPending(taskState) ? <AccessTimeFilledRounded data-testid="task-status-chip-icon" /> : undefined}
      onDelete={isPending(taskState) ? () => {} : undefined}
      size="small"
      sx={{
        '& .MuiChip-deleteIcon': {
          color: TASK_STATE_TEXT_COLOR[taskState],
        },
        backgroundColor: TASK_STATE_COLOR[taskState],
        color: TASK_STATE_TEXT_COLOR[taskState],
        padding: SPACING.spacingSm,
        alignItems: 'center',
      }}
    ></Chip>
  )
}
